import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useState } from 'react';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

interface ItemType {
    img: string[];
    name: string;
    text: string;
    webp: string[];
}

const I_CA: React.FC = () => {
    const { t } = useLang('dpux');
    const webpOrJpg = useWebpOrJpg('#delta-pro-ultra-x-modal-I');

    const items: ItemType[] = [
        {
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1760421545641/pc_Connect%20via%20Transfer%20Switch.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1760421545382/m_Connect%20via%20Transfer%20Switch.jpg',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1760421592254/pc_Connect2.webp',
                'https://websiteoss.ecoflow.com/upload/image/1760421591814/m_Connect2.webp',
            ],
            name: t('I_modal_name1'),
            text: t('I_modal_text1'),
        },
        {
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1760421545316/pc_Connect%20via%20Inlet%20box.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1760421544978/m_Connect%20via%20Inlet%20box.jpg',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1760421591038/pc_Connect1.webp',
                'https://websiteoss.ecoflow.com/upload/image/1760421590939/m_Connect1.webp',
            ],
            name: t('I_modal_name2'),
            text: t('I_modal_text2'),
        },
    ];

    const [enter, setEnter] = useState(false);
    useEffect(() => {
        const ani = AniContainer.create({
            triggerElement: '#delta-pro-ultra-x-modal-I',
            triggerHook: 1,
            offset: '30%',
            duration: '100%',
            onEnter: () => {
                setEnter(true);
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    setEnter(false);
                }
            },
        });

        return () => {
            ani.destroy();
        };
    }, []);

    return (
        <section
            className={`${css.section} delta-pro-ultra-x-I dpux-M-I GtmModuleData-section`}
            id="delta-pro-ultra-x-modal-I"
            data-section-id={'delta-pro-ultra-x-modal-I'}
            data-section-title={t('I_modal_title')}
        >
            <p className={`I-title ${enter ? 'enter' : ''}`}>{t('I_modal_title')}</p>
            <ul className={`I-items-box ${enter ? 'enter' : ''}`}>
                {items.map((item: ItemType, k: number) => (
                    <li className="I-item" key={k}>
                        <div className="item-img">
                            <EcoImg pc={webpOrJpg(item.img[0], item.webp[0])} h5={webpOrJpg(item.img[1], item.webp[1])} />
                        </div>
                        <p className="item-name">{item.name}</p>
                        <p className="item-text">{item.text}</p>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default I_CA;
